
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistic",
      function () {
        return require("private-next-pages/statistic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistic"])
      });
    }
  